import sanityClient from "@sanity/client"

const client = sanityClient({
  projectId: process.env.SANITY_PROJECT_ID,
  dataset: process.env.SANITY_DATASET,
  token: process.env.SANITY_TOKEN,
  apiVersion: "2021-08-31",
})

export const preparePreviewPage = async (parentId, pageId) => {
  const output = {
    page: null,
    meta: {
      client: {},
      ctaBlock: {},
      form: {},
      settings: {},
      sidebarInternalLinks: {},
    },
  }
  let docs = await client.fetch(
    `*[!defined(parent) && references("${parentId}")]`
  )
  docs = docs.filter(item => {
    if (
      item._id.indexOf("drafts.") === -1 &&
      docs.find(find => find._id === `drafts.${item._id}`)
    ) {
      return false
    }
    return true
  })
  docs.forEach(item => {
    if (!pageId && item._type === "startpage") {
      output.page = item
    } else if (item._type === "page" && item._id.indexOf(pageId) !== -1) {
      output.page = item
    } else {
      output.meta[item._type] = item
    }
  })
  if (output.meta.settings.navigation) {
    output.meta.settings.navigation = output.meta.settings.navigation.map(
      item => docs.find(v => v._id.indexOf(item._ref) !== -1)
    )
  }
  return output
}
